/** Русские лейблы для enum'ов поручения. */

export const TRANSPORT_MODE_LABEL: Record<string, string> = {
  RAIL: 'Железнодорожный',
  AIR: 'Воздушный',
  INLAND_WATER: 'Внутренний водный',
  SEA: 'Морской / речной',
  AUTO: 'Автодорожный',
  MULTIMODAL: 'Мультимодальный',
  ANY: 'Любой',
};

export const ORDER_DIRECTION_LABEL: Record<string, string> = {
  DOMESTIC: 'Внутренняя',
  IMPORT: 'Импортная',
  EXPORT: 'Экспортная',
  TRANSIT: 'Транзитная',
};

export const transportLabel = (m: string | null | undefined): string =>
  (m && TRANSPORT_MODE_LABEL[m]) || m || '—';

/** Тип пункта стыковки плеч маршрута. */
export const ROUTE_POINT_KIND_LABEL: Record<string, string> = {
  SHIPPER: 'Грузоотправитель',
  CONSIGNEE: 'Грузополучатель',
  STATION: 'Станция',
  PORT: 'Порт',
  AIRPORT: 'Аэропорт',
  TERMINAL: 'Терминал / склад',
  CUSTOMS: 'Таможенный пост',
  OTHER: 'Иное',
};
export const routePointKindLabel = (k: string | null | undefined): string =>
  (k && ROUTE_POINT_KIND_LABEL[k]) || k || '—';

export const directionLabel = (d: string | null | undefined): string =>
  (d && ORDER_DIRECTION_LABEL[d]) || d || '—';

/** Статусы поручения — русские лейблы и цвета бейджей. */
export const ORDER_STATUS_LABEL: Record<string, string> = {
  DRAFT: 'Черновик',
  SUBMITTED: 'Подано',
  QUOTED: 'Котировано',
  ACCEPTED: 'Принято',
  REJECTED: 'Отклонено',
  CANCELLED: 'Отменено',
  IN_PROGRESS: 'В работе',
  COMPLETED: 'Завершено',
};

export const ORDER_STATUS_COLOR: Record<string, string> = {
  DRAFT: 'gray',
  SUBMITTED: 'blue',
  QUOTED: 'cyan',
  ACCEPTED: 'green',
  REJECTED: 'red',
  CANCELLED: 'red',
  IN_PROGRESS: 'orange',
  COMPLETED: 'teal',
};

export const orderStatusLabel = (s: string | null | undefined): string =>
  (s && ORDER_STATUS_LABEL[s]) || s || '—';
export const orderStatusColor = (s: string | null | undefined): string =>
  (s && ORDER_STATUS_COLOR[s]) || 'gray';

/** Статусы котировки. */
export const QUOTE_STATUS_LABEL: Record<string, string> = {
  PROPOSED: 'Предложена',
  ACCEPTED: 'Принята',
  REJECTED: 'Отклонена',
  EXPIRED: 'Истекла',
  REVOKED: 'Отозвана',
};
export const quoteStatusLabel = (s: string | null | undefined): string =>
  (s && QUOTE_STATUS_LABEL[s]) || s || '—';

/** Статусы перевозки. */
export const SHIPMENT_STATUS_LABEL: Record<string, string> = {
  CREATED: 'Создана',
  PICKED_UP: 'Груз забран',
  IN_TRANSIT: 'В пути',
  ARRIVED: 'Прибыла',
  DELIVERED: 'Доставлена',
  CLOSED: 'Закрыта',
  CANCELLED: 'Отменена',
};
export const shipmentStatusLabel = (s: string | null | undefined): string =>
  (s && SHIPMENT_STATUS_LABEL[s]) || s || '—';

/** Типы событий груза. */
export const CARGO_EVENT_TYPE_LABEL: Record<string, string> = {
  RECEIVED: 'Принято',
  HANDLING: 'Обработка',
  LOADED: 'Погружено',
  STORED: 'На хранении',
  IN_TRANSIT: 'В пути',
  UNLOADED: 'Выгружено',
  HANDED_OVER: 'Передано',
  DELIVERED: 'Доставлено',
};
export const cargoEventTypeLabel = (s: string | null | undefined): string =>
  (s && CARGO_EVENT_TYPE_LABEL[s]) || s || '—';

/** Способы платежа. */
export const PAYMENT_METHOD_LABEL: Record<string, string> = {
  BANK_TRANSFER: 'Банковский перевод',
  CARD: 'Карта',
  CASH: 'Наличные',
  OTHER: 'Иное',
};
export const paymentMethodLabel = (s: string | null | undefined): string =>
  (s && PAYMENT_METHOD_LABEL[s]) || s || '—';
